// "lat,lng" / { lat, lng } / "0,0" terdeteksi sebagai koordinat tidak valid
export const parseCoordinate = (coordinate) => {
  let lat;
  let lng;

  if (!coordinate) return null;

  if (typeof coordinate === "object") {
    lat = Number(coordinate.lat);
    lng = Number(coordinate.lng);
  } else {
    const [rawLat, rawLng] = String(coordinate).split(",");
    if (rawLng === undefined) return null;
    lat = Number(rawLat);
    lng = Number(rawLng);
  }

  const isValid =
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    Math.abs(lat) <= 90 &&
    Math.abs(lng) <= 180 &&
    !(lat === 0 && lng === 0);

  return isValid ? { lat, lng } : null;
};
